module.exports = __webpack_public_path__ + "img/fopeaVacaMuerta6.7af94ab4.jpg";